<!--特殊演示系统登录界面-->
<template>
	<div class="loginContainer flexCenter" :style="loginBg" @click.stop="focus = 0">
		<div class="systemLinks" :style="resourcesStore.getBackgroudImageStyle('/demoSystem/linkBg.png')">
			<div v-for="(item,index) in systemList" class="systemLink" :style="getStyle(index)" @click="jump(item)">
				<img :src="resourcesStore.getResourcesByName(systemAct == index ? item.icol: item.ico)" alt="" />
				<p :class="{'systemNameAct': systemAct == index}">{{item.nameP1}}<br />{{item.nameP2}}</p>
			</div>
		</div>
		<div class="inputInfo" :style="resourcesStore.getBackgroudImageStyle('/demoSystem/loginBg.png')">
			<p class="systemName">{{title}}</p>
			<div class="inputContainer" :class="{'inputContainerFocus':focus == 1}" @click.stop="focus = 1" style="margin-bottom: 36px;">
				<img :src="userSrc" alt="" /><input type="text" placeholder="用户名" v-model="userCode" />
			</div>
			<div class="inputContainer" :class="{'inputContainerFocus':focus == 2}" @click.stop="focus = 2">
				<img :src="keySrc" alt="" /><input type="password" placeholder="密码" v-model="password" />
			</div>
			<div class="rememberUserNameAndPsw"><img @click="rememberChecked = !rememberChecked" :src="rememberSrc" alt="" /><span>记住用户名密码</span></div>
			<span class="loginBtn loginButton" @click="loginButton">登 录</span>
		</div>
		<!-- 版权所有 -->
		<div class="information flexCenterColumn">
			<a v-for="item in copyRight" :href="copyRightUrl" target="_Blank">{{item}}</a>
		</div>
		<div class="qrcodediv">
			<!-- 底部app扫码用的二维码，每个单位可能不一样 -->
			<div class="qrcode" v-for="item in qrCodeList">
				<img :src="item.url" />
				<p>{{item.name}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {},
		data() {
			return {
				userCode: undefined,
				password: undefined,
				focus: 0,
				rememberChecked: false,
				systemAct: -1,
				systemList: [],
				copyRight: undefined,
				copyRightUrl: undefined,
				qrCodeList: undefined,
			}
		},
		created() {
			this.systemList = [{
				nameP1: '学校能源',
				nameP2: '管理系统',
				systemImg: '/demoSystem/system_jsp0.png',
				url: ''
			}, {
				nameP1: '工业企业能源',
				nameP2: '管理系统',
				systemImg: '/demoSystem/system_jsp1.png',
				url: 'http://140.143.32.46:9012/'
			}, {
				nameP1: '建筑能效',
				nameP2: '管理系统',
				systemImg: '/demoSystem/system_jsp2.png',
				url: ''
			}, {
				nameP1: '温度在线',
				nameP2: '监测系统',
				systemImg: '/demoSystem/system_jsp3.png',
				checked: true, //当前应该选中的系统
				url: ''
			}, {
				nameP1: '用电服务',
				nameP2: '管理系统',
				systemImg: '/demoSystem/system_jsp4.png',
				url: ''
			}, {
				nameP1: '电能',
				nameP2: '管理系统',
				systemImg: '/demoSystem/system_jsp5.png',
				url: ''
			}, {
				nameP1: '设备在线',
				nameP2: '监测系统',
				systemImg: '/demoSystem/system_jsp6.png',
				url: ''
			}, {
				nameP1: '智能变配电',
				nameP2: '监测系统',
				systemImg: '/demoSystem/system_jsp7.png',
				url: 'http://120.79.206.40:18002/#/'
			}, {
				nameP1: '变电站综合',
				nameP2: '自动化系统',
				systemImg: '/demoSystem/system_jsp8.png',
				url: ''
			}, {
				nameP1: '智能照明',
				nameP2: '管理系统',
				systemImg: '/demoSystem/system_jsp9.png',
				url: ''
			}, {
				nameP1: '调度集控',
				nameP2: '中心系统',
				systemImg: '/demoSystem/system_jsp10.png',
				url: ''
			}, {
				nameP1: '楼宇自动化',
				nameP2: '管理系统',
				systemImg: '/demoSystem/system_jsp11.png',
				url: ''
			}, {
				nameP1: '配水自动化',
				nameP2: '系统',
				systemImg: '/demoSystem/system_jsp12.png',
				url: ''
			}, {
				nameP1: '电力需求侧',
				nameP2: '管理平台',
				systemImg: '/demoSystem/system_jsp13.png',
				url: ''
			}, {
				nameP1: '光伏电站',
				nameP2: '监控系统',
				systemImg: '/demoSystem/system_jsp14.png',
				url: ''
			}]
			this.systemAct = this.systemList.findIndex(item => item.checked == true)
		},
		mounted() {
			debugPage = this
			enableWedoLog()
			//初始化配置
			this.$store.menuStore.state.menuType = 1
			//恢复上次选中的记住密码和账号密码
			this.userCode = localStorage.getItem('wedoDemoSystemRememberUserCode')
			this.password = localStorage.getItem('wedoDemoSystemRememberPSW')
			if(!isempty(this.userCode) && !isempty(this.password)) {
				this.rememberChecked = true
			} else {
				this.userCode = undefined
				this.password = undefined
				localStorage.removeItem('wedoDemoSystemRememberUserCode')
				localStorage.removeItem('wedoDemoSystemRememberPSW')
			}
			//FIXME 测试时自动登录
			//this.test()
			//设置版权声明
			this.copyRight = DWSystemSetting.copyRight
			this.copyRightUrl = DWSystemSetting.copyRightUrl
			//设置二维码列表
			this.qrCodeList = DWSystemSetting.qrCodeList
			//为二维码增加参数避免缓存
			for(var i = 0, len = this.qrCodeList.length; i < len; i++) {
				var item = this.qrCodeList[i]
				item.url = item.url + "?version=" + new Date().formatByDate()
			}
		},
		destroyed() {},
		computed: {
			resourcesStore() {
				return this.$store.resourcesStore.getters
			},
			loginBg() {
				return this.resourcesStore.getBackgroudImageStyle('/demoSystem/background.jpg')
			},
			userSrc() {
				return this.resourcesStore.getResourcesByName('/demoSystem' + (this.focus == 1 ? '/icon_user_act.png' :
					'/icon_user.png'))
			},
			keySrc() {
				return this.resourcesStore.getResourcesByName('/demoSystem' + (this.focus == 2 ? '/icon_key_act.png' :
					'/icon_key.png'))
			},
			rememberSrc() {
				return this.resourcesStore.getResourcesByName('/demoSystem' + (this.rememberChecked ? '/remember_checked.png' :
					'/remember_unchecked.png'))
			},
			webConfig() {
				return this.$store.cacheStore.getters.getWebConfig
			},
			getStyle() {
				return num => {
					if(num == this.systemAct) {
						return this.resourcesStore.getBackgroudImageStyle('/demoSystem/system_act.png')
					} else {
						return this.resourcesStore.getBackgroudImageStyle('/demoSystem/system_normal.png')
					}
				}
			},
			title() {
				if(this.webConfig == undefined) {
					return ''
				}
				/*document.title = this.webConfig.Title*/
				return DWSystemSetting.demoSystemInfo.name
			},
		},
		watch: {},
		methods: {
			jump(item) {
				if(isempty(item.url)) {
					this.$dialogMethod.showMessage('网站未开放!')
					return
				}
				window.location.href = item.url
			},
			test() {
				this.userCode = 'ydtest'
				this.password = '1'
				enableWedoLog()
				this.loginButton()
				//调试的
				setTimeout(() => {
					this.$router.push("/usePowerUnit")
				}, 4000)
			},
			loginButton() {
				//特殊处理40演示上的登录
				if(!isempty(DWSystemSetting.demoSystemInfo)) {
					this.userCode += DWSystemSetting.demoSystemInfo.loginSplice
				}
				//登录
				this.$api.userApi.login(this.userCode, this.password == localStorage.getItem('wedoDemoSystemRememberPSW') ? this.password :
					hex_md5(this.password), "Web",null, respon => {
						//判断是否要记住密码
						if(this.rememberChecked) {
							localStorage.setItem('wedoDemoSystemRememberUserCode', this.userCode)
							localStorage.setItem('wedoDemoSystemRememberPSW', this.password == localStorage.getItem(
								'wedoDemoSystemRememberPSW') ? this.password : hex_md5(this.password))
						} else {
							localStorage.removeItem('wedoDemoSystemRememberUserCode')
							localStorage.removeItem('wedoDemoSystemRememberPSW')
						}
						localStorage.setItem('nowWedoSystemUserCode', this.userCode)
						//获取用户信息
						this.$store.userStore.commit("setNowUserCode", this.userCode)
						//获取用户单位信息
						this.$store.unitStore.commit("getUnitTree")
						this.$dialogMethod.showMessage('登录成功，正在跳转。。。')
						setTimeout(() => {
							//获取菜单并且进入主界面
							this.$store.menuStore.commit("getMenuList")
						}, 1000)
						//连接新后台
						this.$wedoWebSocketClient.connect(respon.webSocketUrl, respon.pkid)
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
			},
		}
	}
</script>

<style scoped>
	.loginContainer {
		height: 100%;
		display: flex;
	}
	
	.systemLinks {
		width: 30%;
		padding-top: 30%;
		position: relative;
		margin-right: 10%;
	}
	
	.systemLink {
		width: 110px;
		height: 110px;
		text-align: center;
		position: absolute;
		cursor: pointer;
	}
	
	.systemLink:nth-child(1) {
		top: -30px;
		left: calc(50% - 65px);
	}
	
	.systemLink:nth-child(2) {
		top: calc(30% - 65px);
		left: calc(100% - 100px);
	}
	
	.systemLink:nth-child(3) {
		top: calc(30% - 65px);
		left: -30px;
	}
	
	.systemLink:nth-child(4) {
		top: calc(100% - 100px);
		left: calc(50% - 65px);
	}
	
	.systemLink:nth-child(5) {
		top: calc(70% - 65px);
		left: -30px;
	}
	
	.systemLink:nth-child(6) {
		top: calc(70% - 65px);
		left: calc(100% - 100px);
	}
	
	.systemLink>img {
		width: 18px;
		height: 18px;
		margin-top: 29px;
	}
	
	.systemLink>p {
		font-size: 9px;
		line-height: 14px;
		margin-top: 4px;
		color: #FFFFFF;
		font-weight: bold;
	}
	
	.systemLink>.systemNameAct {
		color: #1B96ED;
	}
	
	.inputInfo {
		padding: 40px 30px;
	}
	
	.systemName {
		font-size: .22rem;
		text-align: center;
		color: #1481F8;
		margin-bottom: 60px;
	}
	
	.inputContainer {
		padding: 0 16px;
		height: 40px;
		border: solid 1px #FFFFFF;
		border-radius: 21px;
		background: #FFFFFF;
		overflow: hidden;
	}
	
	.inputContainerFocus {
		border-color: #1481F8;
		box-shadow: 0 0 3px #1481F8;
	}
	
	.inputContainer>img {
		width: 18px;
		height: 18px;
		float: left;
		margin-top: 11px;
	}
	
	.inputContainer>input {
		width: 240px;
		border: none;
		margin-left: 6px;
		height: 100%;
		box-sizing: border-box;
		box-shadow: none;
		outline: none;
	}
	
	.inputContainer>input:-webkit-autofill {
		-webkit-box-shadow: 0 0 0 1000px #FFFFFF inset !important;
	}
	
	.rememberUserNameAndPsw {
		margin-top: 24px;
	}
	
	.rememberUserNameAndPsw>img {
		width: 20px;
		height: 20px;
		vertical-align: top;
		margin-right: 6px;
		cursor: pointer;
	}
	
	.rememberUserNameAndPsw>span {
		line-height: 22px;
		font-size: .12rem;
		color: gray;
	}
	
	.loginBtn {
		display: block;
		text-align: center;
		line-height: 42px;
		width: 100%;
		height: 42px;
		border-radius: 21px;
		margin-top: 36px;
		cursor: pointer;
	}
	
	.information {
		position: absolute;
		z-index: 1;
		bottom: 20px;
		width: 100%;
	}
	
	.information>a {
		display: block;
		color: #bbb;
		font-size: 14px;
		text-align: center;
		text-decoration: none;
	}
	
	.qrcodediv {
		position: absolute;
		left: 5%;
		bottom: 20px;
	}
	
	.qrcode {
		display: inline-flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		margin-right: 40px;
	}
	
	.qrcode>img {
		width: 100px;
		height: 100px;
	}
	
	.qrcode>p {
		color: white;
		text-align: center;
	}
</style>